import React from "react";
import ReactMarkdown from "react-markdown";
import { Card, Container } from "react-bootstrap";

const FaqPage = () => {

    const questions =
        [
            {
                "question": "What is the RBA Travel Allowance program?",
                "answer": "The RBA Travel Allowance program consists of two types of allowances to support employees' personal travel and vacation expenses:\n\n1. **Annual Allowance:** Every employee receives $1,000 annually to use for travel-related expenses\n\n2. **Service Anniversary Allowances:** Employees receive special one-time allowances to celebrate service milestones:\n- At 10 years of service: $1,500 one-time allowance\n- At 15 years of service: $1,500 one-time allowance\n\nSee [Anniversary Gifts](https://rbaconsulting.sharepoint.com/sites/CorporateServices/SitePages/RBA-Anniversary-Gifts.aspx) on Connect for full details regarding anniversary benefits.\n\nBoth types of allowances are part of RBA's commitment to supporting employee work-life balance and recognizing employee dedication to the company."
            },
            {
                "question": "What can I use the allowance for?",
                "answer": "The allowance is intended for travel and travel-related expenses, including but not limited to:\n\n- Airline tickets\n- Rental cars\n- Hotel accommodations\n- Meals while on vacation\n\nPlease contact HR with any questions regarding what may qualify.\n\nRBA reserves the right to deny any expense that is not deemed to be within the spirit of the program."
            },
            {
                "question": "How do I submit expenses for reimbursement?",
                "answer": "To use your **Annual Travel Allowance** dollars, submit expenses through Concur using the \"Annual Travel Allowance\" code and use subaccount 00-00. If you have more than one **annual allowance** with a remaining balance, the expenses will be applied to the allowances from oldest to newest.\n\nTo use your **10-Year Service Anniversary** dollars, submit through Concur using expense type \"Employee 10 Year Gift\" and use subaccount 00-00.\n\nTo use your **15-Year Service Anniversary** dollars, submit through Concur using expense type \"Employee 15 Year Gift\"\n and use subaccount 00-00."
            },
            {
                "question": "Do I have to use the entire allowance at once?",
                "answer": "No, you can use your allowance throughout the year by submitting multiple expense reports as needed."
            },
            {
                "question": "What happens to unused allowance at the end of the year?",
                "answer": "Unused **annual** allowances can be rolled over for up to 3 years. This means you can accumulate allowances if you don't use it all in a given year, but amounts older than 3 years will expire.\n\n**Anniversary** allowances do not expire."
            },
            {
                "question": "How can I check my allowance balance?",
                "answer": "You can track your allowance balance through the RBA EPIIC app. The app shows your current balance, transaction history, and any upcoming expirations."
            },
            {
                "question": "When do new allowances get issued?",
                "answer": "**Annual** allowances will be issued on 5/1 for 2025, and on 1/1 each year thereafter. **Service Anniversary** allowances will be issued on your hire date."
            },
            {
                "question": "What happens to my allowance if I leave RBA?",
                "answer": "Per policy, if you leave RBA, any remaining balance in your travel allowance will be forfeited upon your termination date."
            },
            {
                "question": "My voucher transaction says \"ADJUSTED - Balance Import\". What does that mean?",
                "answer": "This transaction type appears for expenses submitted prior to 2022. Expense details older than 2022 were not imported. As such, one adjustment was made to reflect previously used amounts. The \"ADJUSTED - Balance Import\" transaction represents this one-time adjustment to establish the correct starting balance."
            }

        ];

        return (
            <div className="p-4">
              <Container fluid="lg">
                <Card>
                  <Card.Body>
                    <Card.Title className="mb-4">Frequently Asked Questions</Card.Title>
                    {questions.map((qna, index) => (
                      <div key={index} className="mb-4">
                        <Card>
                          <Card.Header>
                            <strong>{qna.question}</strong>
                          </Card.Header>
                          <Card.Body>
                            <ReactMarkdown className="faq">{qna.answer}</ReactMarkdown>
                          </Card.Body>
                        </Card>
                      </div>
                    ))}
                  </Card.Body>
                </Card>
              </Container>
            </div>
          );
        };
        
        export default FaqPage;